import React , {useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {getPopularVideos} from '../action/videoAction';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import '../screen/watchscreen/_watchscreen.scss';
import moment from 'moment';
import { useHistory } from 'react-router';
import numeral from 'numeral';
import randomstring from 'randomstring';

const Videoplayersidebar = () =>{
    const { videos, loading } = useSelector(state => state.homevideo);
    const relativeVidieo = useSelector(state => state.relatedVideos);
    console.log(relativeVidieo);
    
    const history = useHistory();
    const dispatch = useDispatch()
    console.log(videos.length);
    if(videos.length==0){
        dispatch(getPopularVideos("All"));
    }

    useEffect(() => {
      console.log(videos);
    }, [])

    const onclickHandler = id =>{
        console.log(id);
        history.push(`/watch/${id}`);
    }
  
    return (
        <>
        {relativeVidieo ? 
        
        relativeVidieo.videos.map(video =>
            <div className="Videoplayersidebar" key={`${video.id}${randomstring.generate()}`} onClick={ ()=>{onclickHandler(video.id.videoId)}}>
                <div className="Watchscreenvideos">
                    <div className="tumbnail_image">
                        <LazyLoadImage src={video.snippet?.thumbnails.medium.url} effect='blur' />
                        <span className="duration">6.50</span>
                    </div>
                    <div className="videoDetail">
                        <h1>{String(video.snippet?.title).substring(0,60)}{String(video.snippet?.title).length>=65}</h1>
                        <p><span>2M Views • </span><span>{moment(video.snippet?.publishedAt).fromNow()}</span></p>
                        <div className="channeldetails">
                            <div className="chaneliconAndname">
                                {/* <LazyLoadImage src={channelIcon?.url} effect='blur' /> */}
                                <h2>{video.snippet?.channelTitle}</h2>
                            </div>
                            {/* <p>{props.data.description}</p> */}
                        </div>
                    </div>
                </div>
            </div>

            )
        : ""}
        </>
    )
}
export default Videoplayersidebar;
